import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let FBIcon = (props) => (
	<SvgIcon {...props} viewBox={"0 0 28 28"}>
		<path
			d="M26 14.073C26 7.406 20.627 2 14 2S2 7.406 2 14.073C2 20.098 6.388 25.093 12.125 26v-8.436H9.077v-3.491h3.048v-2.66c0-3.026 1.792-4.698 4.533-4.698 1.313 0 2.686.236 2.686.236v2.97h-1.513c-1.49 0-1.956.931-1.956 1.887v2.265h3.328l-.532 3.49h-2.796V26C21.612 25.095 26 20.1 26 14.073z"
			fill="#1977F3"
		/>
	</SvgIcon>
);
FBIcon = memo(FBIcon);
FBIcon.displayName = "FBIcon";
FBIcon.muiName = "FBIcon";

export default FBIcon;
